import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslocoModule } from '@jsverse/transloco';
import { IChangePassword } from '../../apis/patient/patient.interface';
import { RequiredAsteriskDirective } from '../../directive/required-asterisk.directive';
import { PasswordValidator } from '../../validators/password.validator';
import { ContactAuthHelper } from '@core/helpers/contact-auth.helper';
import { InputPhoneEmailComponent } from '../input-phone-email/input-phone-email.component';
import { UserTypeEnum } from '@oranta-mis/sdk';
declare let bootstrap: any;

@Component({
  selector: 'app-change-password-modal',
  imports: [TranslocoModule, ReactiveFormsModule, RequiredAsteriskDirective, InputPhoneEmailComponent],
  templateUrl: './change-password-modal.component.html',
  styleUrl: './change-password-modal.component.scss',
})
export class ChangePasswordModalComponent implements OnChanges {
  @Output() public formData: EventEmitter<IChangePassword> = new EventEmitter();
  @Input() public isLoading: boolean = false;
  @Input({ required: true }) public whoSignIn!: UserTypeEnum;

  public readonly UserTypeEnum = UserTypeEnum;
  private modalInstance!: any;

  public openModal() {
    const modalElement = document.getElementById('exampleModal');
    if (modalElement) {
      this.modalInstance = new bootstrap.Modal(modalElement, {
        backdrop: 'static',
        keyboard: false,
      });
      this.modalInstance.show();
    }
  }

  passwordChecked: boolean = false;
  form!: FormGroup;

  constructor(private fb: FormBuilder) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['whoSignIn']) {
      this.buildForm(this.whoSignIn);
    }
  }

  private buildForm(type: UserTypeEnum): void {
    this.form =
      type === UserTypeEnum.patient
        ? this.fb.group(
            {
              contact: [null, [Validators.required, ContactAuthHelper.emailOrPhoneValidator()]],
              passwordOld: ['', [Validators.required]],
              passwordNew: ['', [Validators.required, PasswordValidator.validate]],
              repeatPassword: ['', [Validators.required]],
            },
            { validators: this.passwordsMatch },
          )
        : this.fb.group(
            {
              email: [null, [Validators.required, Validators.email]],
              passwordOld: ['', [Validators.required]],
              passwordNew: ['', [Validators.required, PasswordValidator.validate]],
              repeatPassword: ['', [Validators.required]],
            },
            { validators: this.passwordsMatch },
          );
  }

  get passwordNew(): FormControl {
    return (<FormControl>this.form.get('passwordNew')) as FormControl;
  }

  get repeatPassword(): FormControl {
    return (<FormControl>this.form.get('repeatPassword')) as FormControl;
  }

  onSubmit() {
    const { repeatPassword, contact, ...formData } = this.form.value;

    if (this.whoSignIn === UserTypeEnum.patient) {
      const resolvedContact = ContactAuthHelper.resolveContact(contact);
      console.log({ ...formData, ...resolvedContact });
      this.formData.emit({ ...formData, ...resolvedContact });
    } else {
      console.log({ ...formData, email: formData.email });
      this.formData.emit({
        password_old: formData.passwordOld,
        password_new: formData.passwordNew,
        email: formData.email,
      });
    }

    this.isLoading = true;
  }

  passwordsMatch(control: AbstractControl) {
    const password = control.get('passwordNew')?.value;
    const confirmPassword = control.get('repeatPassword')?.value;
    return password === confirmPassword ? null : { passwordMismatch: true };
  }

  closeDialogModal() {
    if (this.modalInstance) {
      this.modalInstance.hide();
    }
  }
}
